export const fightersPageTranslations = {
    en: {
        search_name_placeholder: "Search by name",
        location_placeholder: "Location",
        combat_sport_placeholder: "Combat Sport",
        weight_class_placeholder: "Weight Class",
        title_holder_placeholder: "Title Holder",
        reset_filters_tooltip: "Reset all filters",
        table_column_gender: "Gender",
        male: "Male",
        female: "Female",
        others: "Others",
        loading_text: "Loading...",
        error_countries: "Failed to load countries",
        gender_placeholder: "Gender",
        error_fighters: "Failed to load fighters",
        error_sports: "Failed to load training disciplines",
        error_weight_classes: "Failed to load weight classes",
        table_column_fighter: "Fighter",
        table_column_phone: "Phone",
        table_column_location: "Location",
        table_column_disciplines: "Disciplines",
        table_column_weight_class: "Weight Class",
        table_column_title: "Title",
        table_column_status: "Status",
        table_column_actions: "Actions",
        table_empty_content: "No fighters found",
        edit_fighter_tooltip: "Edit fighter",
        pagination_showing: "Showing {start} to {end} of {total} fighters",
        all_locations: "All Locations",
        all_sports: "All Sports",
        all_weight_classes: "All Weight Classes",
        all_titles: "All Titles",
        yes: "Yes",
        no: "No",
        na: "N/A",
    },
    de: {
        search_name_placeholder: "Nach Namen suchen",
        location_placeholder: "Standort",
        combat_sport_placeholder: "Kampfsport",
        weight_class_placeholder: "Gewichtsklasse",
        gender_placeholder: "Geschlecht auswählen",
        table_column_gender: "Geschlecht",
        title_holder_placeholder: "Titelträger",
        reset_filters_tooltip: "Alle Filter zurücksetzen",
        male: "Männlich",
        female: "Weiblich",
        others: "Andere",
        loading_text: "Laden...",
        error_countries: "Länder konnten nicht geladen werden",
        error_fighters: "Kämpfer konnten nicht geladen werden",
        error_sports: "Trainingsdisziplinen konnten nicht geladen werden",
        error_weight_classes: "Gewichtsklassen konnten nicht geladen werden",
        table_column_fighter: "Kämpfer",
        table_column_phone: "Telefon",
        table_column_location: "Standort",
        table_column_disciplines: "Disziplinen",
        table_column_weight_class: "Gewichtsklasse",
        table_column_title: "Titel",
        table_column_status: "Status",
        table_column_actions: "Aktionen",
        table_empty_content: "Keine Kämpfer gefunden",
        edit_fighter_tooltip: "Kämpfer bearbeiten",
        pagination_showing: "Zeigt {start} bis {end} von {total} Kämpfern",
        all_locations: "Alle Standorte",
        all_sports: "Alle Sportarten",
        all_weight_classes: "Alle Gewichtsklassen",
        all_titles: "Alle Titel",
        yes: "Ja",
        no: "Nein",
        na: "N/V",
    },
    hr: {
        search_name_placeholder: "Pretraži po imenu",
        location_placeholder: "Lokacija",
        combat_sport_placeholder: "Borilački sport",
        weight_class_placeholder: "Kategorija težine",
        title_holder_placeholder: "Nositelj titule",
        reset_filters_tooltip: "Resetiraj sve filtre",
        table_column_gender: "Spol",
        male: "Muško",
        female: "Žensko",
        others: "Ostalo",
        loading_text: "Učitavanje...",
        error_countries: "Neuspjelo učitavanje zemalja",
        gender_placeholder: "Odaberite spol",
        error_fighters: "Neuspjelo učitavanje boraca",
        error_sports: "Neuspjelo učitavanje sportova",
        error_weight_classes: "Neuspjelo učitavanje kategorija težine",
        table_column_fighter: "Borac",
        table_column_phone: "Telefon",
        table_column_location: "Lokacija",
        table_column_disciplines: "Discipline",
        table_column_weight_class: "Kategorija težine",
        table_column_title: "Titula",
        table_column_status: "Status",
        table_column_actions: "Akcije",
        table_empty_content: "Nema pronađenih boraca",
        edit_fighter_tooltip: "Uredi borca",
        pagination_showing: "Prikazujem {start} do {end} od {total} boraca",
        all_locations: "Sve lokacije",
        all_sports: "Svi sportovi",
        all_weight_classes: "Sve kategorije težine",
        all_titles: "Sve titule",
        yes: "Da",
        no: "Ne",
        na: "N/A",
    }

};